import { Currency } from '@ps/web-core-enums';
import { select } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import CurrencySymbol from '@swf/components/CurrencySymbol/CurrencySymbol';

import useCurrencyFetcher from '../../utils/utils';

import { TXTWCL_Converted_Limit } from './ConversionSubLabel.messages.json';
import { conversion, conversionAmount, conversionTitle } from './ConversionSubLabel.scss';

interface Props {
  amount: number;
  fromCurrency: Currency;
  targetCurrency?: Currency;
}

const ConversionSubLabel: React.FC<Props> = ({ amount = 0, fromCurrency, targetCurrency }) => {
  const defaultTargetCurrency =
    targetCurrency ?? useSelector(select.account.getLimitCurrency) ?? Currency.USDollar;

  if (fromCurrency === defaultTargetCurrency) {
    return;
  }

  const { convertedAmount } = useCurrencyFetcher(amount, defaultTargetCurrency, fromCurrency);

  return (
    <div className={conversion}>
      <div className={conversionTitle}>
        <Translation {...TXTWCL_Converted_Limit} />
      </div>
      <div className={conversionAmount}>
        {convertedAmount} <CurrencySymbol currency={defaultTargetCurrency} trimSpace />
      </div>
    </div>
  );
};

export default ConversionSubLabel;
